/**
 * First-load sort for Shared Assessments (Join Request list).
 * Backend JoinVqaRequest list is already OrderByDescending(join_vqa_request_created_on);
 * this config aligns the FE sort indicator / client re-sort of the current page.
 */
export const SHARED_ASSESSMENTS_DEFAULT_SORT_CONFIG = {
  join_vqa_request_created_on: { direction: "desc" },
};
